import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//MUI
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Toolbar,
  Box,
  Divider,
  ListItemText,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import FlagIcon from "@mui/icons-material/Flag";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import MapIcon from "@mui/icons-material/Map";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MoneyIcon from "@mui/icons-material/Money";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import GavelIcon from "@mui/icons-material/Gavel";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import PlaceIcon from "@mui/icons-material/Place";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import AnalyticsIcon from "@mui/icons-material/Analytics";

type Props = {
  handleDrawerToggle?: () => void;
};

const AdminSidebar = ({ handleDrawerToggle }: Props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const modulePath = useMemo(() => {
    return pathname.split("admin/")[1];
  }, [pathname]);

  const navigateHandler = (path: string) => {
    navigate(`/admin/${path}`);
    if (handleDrawerToggle) {
      handleDrawerToggle();
    }
  };

  return (
    <div>
      <Toolbar />
      <Box>
        <List>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "bu" || modulePath === undefined}
              onClick={() => navigateHandler("bu")}
            >
              <ListItemIcon color="inherit">
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText primary="BU" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "sbu"}
              onClick={() => navigateHandler("sbu")}
            >
              <ListItemIcon color="inherit">
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText primary="SBU" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "sbg"}
              onClick={() => navigateHandler("sbg")}
            >
              <ListItemIcon color="inherit">
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText primary="SBG" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "csgo"}
              onClick={() => navigateHandler("csgo")}
            >
              <ListItemIcon color="inherit">
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText primary="CSGO" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "users"}
              onClick={() => navigateHandler("users")}
            >
              <ListItemIcon color="inherit">
                <GroupIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "roles"}
              onClick={() => navigateHandler("roles")}
            >
              <ListItemIcon color="inherit">
                <FollowTheSignsIcon />
              </ListItemIcon>
              <ListItemText primary="Roles" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "customers"}
              onClick={() => navigateHandler("customers")}
            >
              <ListItemIcon color="inherit">
                <SupervisedUserCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Customers" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "customerType"}
              onClick={() => navigateHandler("customerType")}
            >
              <ListItemIcon color="inherit">
                <MergeTypeIcon />
              </ListItemIcon>
              <ListItemText primary="Customer Type" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "contractType"}
              onClick={() => navigateHandler("contractType")}
            >
              <ListItemIcon color="inherit">
                <GavelIcon />
              </ListItemIcon>
              <ListItemText primary="Contract Type" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "projectcompetitors"}
              onClick={() => navigateHandler("projectcompetitors")}
            >
              <ListItemIcon color="inherit">
                <Diversity3Icon />
              </ListItemIcon>
              <ListItemText primary="Project Competitors" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "projects"}
              onClick={() => navigateHandler("projects")}
            >
              <ListItemIcon color="inherit">
                <GroupWorkIcon />
              </ListItemIcon>
              <ListItemText primary="Projects" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "projectsStatus"}
              onClick={() => navigateHandler("projectsStatus")}
            >
              <ListItemIcon color="inherit">
                <GroupWorkIcon />
              </ListItemIcon>
              <ListItemText primary="Projects Status" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "projectswinloss"}
              onClick={() => navigateHandler("projectswinloss")}
            >
              <ListItemIcon color="inherit">
                <AnalyticsIcon />
              </ListItemIcon>
              <ListItemText primary="Projects Bid Status" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "segmentLOBs"}
              onClick={() => navigateHandler("segmentLOBs")}
            >
              <ListItemIcon color="inherit">
                <AcUnitIcon />
              </ListItemIcon>
              <ListItemText primary="Segment LOBs" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "segmentClassifications"}
              onClick={() => navigateHandler("segmentClassifications")}
            >
              <ListItemIcon color="inherit">
                <AccountTreeIcon />
              </ListItemIcon>
              <ListItemText primary="Segment Classifications" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "geographies"}
              onClick={() => navigateHandler("geographies")}
            >
              <ListItemIcon color="inherit">
                <LocationCityIcon />
              </ListItemIcon>
              <ListItemText primary="Geographies" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "fundingSources"}
              onClick={() => navigateHandler("fundingSources")}
            >
              <ListItemIcon color="inherit">
                <MoneyIcon />
              </ListItemIcon>
              <ListItemText primary="Funding Sources" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "tenderBandwidths"}
              onClick={() => navigateHandler("tenderBandwidths")}
            >
              <ListItemIcon color="inherit">
                <AccountBalanceWalletIcon />
              </ListItemIcon>
              <ListItemText primary="Tender Bandwidths" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "competitionIntensities"}
              onClick={() => navigateHandler("competitionIntensities")}
            >
              <ListItemIcon color="inherit">
                <AutoAwesomeMotionIcon />
              </ListItemIcon>
              <ListItemText primary="Competition Intensities" />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider sx={{ bgcolor: "#000" }} />
        <List>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "countries"}
              onClick={() => navigateHandler("countries")}
            >
              <ListItemIcon color="inherit">
                <FlagIcon />
              </ListItemIcon>
              <ListItemText primary="Countries" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "states"}
              onClick={() => navigateHandler("states")}
            >
              <ListItemIcon color="inherit">
                <PlaceIcon />
              </ListItemIcon>
              <ListItemText primary="States" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "customerGreenClassifications"}
              onClick={() => navigateHandler("customerGreenClassifications")}
            >
              <ListItemIcon color="inherit">
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="Customer Green Classifications" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "sbubumapping"}
              onClick={() => navigateHandler("sbubumapping")}
            >
              <ListItemIcon color="inherit">
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="SBU BU Map" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "segmentClassificationMap"}
              onClick={() => navigateHandler("segmentClassificationMap")}
            >
              <ListItemIcon color="inherit">
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="Segment Classification Map" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "segmentbumapping"}
              onClick={() => navigateHandler("segmentbumapping")}
            >
              <ListItemIcon color="inherit">
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="Segment BU Map" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              selected={modulePath === "userhierarchy"}
              onClick={() => navigateHandler("userhierarchy")}
            >
              <ListItemIcon color="inherit">
                <Diversity3Icon />
              </ListItemIcon>
              <ListItemText primary="User Hierarchy" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </div>
  );
};

export default AdminSidebar;
